// src/components/RegulationModal.jsx
import React, { useState } from 'react';


const RegulationModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="reg-button" onClick={() => setOpen(true)}>
        ПОЛОЖЕНИЕ
      </button>

      {open && (
        <div className="reg-overlay" onClick={() => setOpen(false)}>
          <div className="reg-modal" onClick={e => e.stopPropagation()}>
            <button className="reg-close" onClick={() => setOpen(false)}>
              ×
            </button>

            <h2>ПОЛОЖЕНИЕ</h2>
            <p className="reg-intro">
              о проведении международного онлайн‑хакатона BrandGlobe Hackathon<br/>
              (утверждено Правлением Международной Ассоциации Маркетинговых Инициатив — МАМИ, протокол № 04‑BG/2025 от 20 марта 2020 г.)
            </p>

            <div className="reg-section">
              <h3>1. Общие положения</h3>
              <p>1.1. BrandGlobe Hackathon (далее — Хакатон) — ежегодное международное соревнование команд выдающихся маркетологов, адаптируемых минимум к трём национальным рынкам.</p>
              <p>1.2. Хакатон проводится в полностью онлайн‑формате на платформе MAMI Connect.</p>
              <p>1.3. Рабочие языки: русский и английский.</p>
              <p>1.4. Настоящее Положение определяет цели, задачи, порядок организации, критерии оценки, состав жюри, процедуру подачи заявок, календарный план, права и обязанности участников, организаторов и экспертов.</p>
            </div>

            <div className="reg-section">
              <h3>2. Организаторы и партнеры</h3>
              <p>2.1. Учредитель и организатор — Международная Ассоциация Маркетинговых Инициатив (МАМИ), Украина (mami.org.ua).</p>
              <p>2.2. Партнеры 2025 г.: Google Cloud EMEA, Figma, HubSpot Academy, UNICEF Innovation Fund, TBWA\Africa, Cloudflare EMEA, Kyiv School of Economics.</p>
              <p>2.3. Оргкомитет МАМИ обеспечивает:</p>
              <ul className='brandhackathon__list'>
                <li>техническую поддержку платформы;</li>
                <li>проверку заявок и антиплагиата;</li>
                <li>взаимодействие с жюри и менторским пулом;</li>
                <li>информационное сопровождение и СМИ‑кампанию.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>3. Цели и задачи</h3>
              <ul className='brandhackathon__list'>
                <li>3.1. Стимулировать развитие кросс‑культурного digital‑брендинга.</li>
                <li>3.2. Выявить и поддержать талантливых маркетологов стран СНГ, ЕС и дальнего зарубежья.</li>
                <li>3.3. Сформировать сообщество для обмена лучшими практиками global‑branding, AI‑маркетинга и ESG‑подходов.</li>
                <li>3.4. Продемонстрировать потенциал креативной индустрии как катализатора международных инноваций.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>4. История и регулярность</h3>
              <p>4.1. Хакатон стартовал в 2020 г. как ответ на глобальный переход бизнеса в онлайн.</p>
              <p>4.2. С 2021 г. проводится 5 ноября.</p>
              <p>4.3. За пять лет в Хакатоне приняли участие 2 600+ команд из 42 стран; 320 вышли в полуфинал, 50 — в финал.</p>
            </div>

            <div className="reg-section">
              <h3>5. География</h3>
              <p>5.1. В 2025 г. к участию приглашены представители 42 стран пяти континентов (Украина, Германия, Польша, США, Канада, Бразилия, ОАЭ, Казахстан, Япония, Индия, ЮАР и др.).</p>
              <p>5.2. Каждая команда обязана обозначить три фокус‑рынка для культурной адаптации бренда.</p>
            </div>

            <div className="reg-section">
              <h3>6. Требования к участникам</h3>
              <ul className='brandhackathon__list'>
                <li>6.1. Команда: 3–6 человек.</li>
                <li>6.2. В составе обязательно: капитан‑маркетолог — руководитель крупного маркетингового отдела с опытом от 3 лет и выдающимися профессиональными достижениями.</li>
                <li>6.3. Возраст участников — не моложе 18 лет.</li>
                <li>6.4. Допускаются смешанные команды разных стран.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>7. Номинации</h3>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Номинация</th>
                      <th>Фокус оценки</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>1</td><td>BrandGlobe Mastermind Grand Prix</td><td>Лидер‑визионер, цельная архитектура бренда, план масштабирования на 3+ рынка</td></tr>
                    <tr><td>2</td><td>Cross‑Culture Navigator Award</td><td>Глубина культурной адаптации, многоязычный контент, soft‑skills капитана</td></tr>
                    <tr><td>3</td><td>Digital Innovation Trailblazer</td><td>Тех‑прорыв (AI/AR/Cloud), связка «технология – ценность бренда», рабочий MVP</td></tr>
                    <tr><td>4</td><td>Global Vision Grand Prix</td><td>Целостный бренд, универсальная айдентика, финансовая модель и стратегия глобального роста</td></tr>
                    <tr><td>5</td><td>Culture Fusion Award</td><td>Интеграция локальных ценностей, языка и визуального кода; этичный сторителлинг</td></tr>
                    <tr><td>6</td><td>Digital Innovation in Branding</td><td>Frontier‑технологии, подтверждённый рост вовлечённости, органичная интеграция в ценность бренда</td></tr>
                    <tr><td>7</td><td>Tech Disruptor Brand</td><td>Уникальность техрешения, ясность УТП, UX, Go‑to‑Market‑roadmap, стратегия комьюнити</td></tr>
                    <tr><td>8</td><td>Fashion & Lifestyle Icon</td><td>Эмоциональный сторителлинг, визуальный почерк, инфлюенсер‑коллаборации, ESG/omni‑канальность</td></tr>
                    <tr><td>9</td><td>Social Impact Champion</td><td>Социальная/экологическая задача, KPI воздействия, финансовая устойчивость</td></tr>
                    <tr><td>10</td><td>Audience Choice Award</td><td>Онлайн‑голоса, вовлечённость, креатив и ясность 1‑минутного видеопитча</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="reg-section">
              <h3>8. Процедура подачи заявок</h3>
              <ul className='brandhackathon__list'>
                <li>8.1. 1 июля — 31 августа: регистрация профиля капитана на MAMI Connect.</li>
                <li>8.2. До 15 сентября 23:59 (EEST): загрузка онлайн‑формы (описание идеи, видео капитана, MVP, логотип, медиаплан).</li>
                <li>8.3. 16–24 сентября: технический скрининг, антиплагиат, присвоение анонимного ID.</li>
                <li>8.4. 25 сентября: объявление short‑list из 60 команд; подтверждение участия.</li>
                <li>8.5. 1 октября — 20 октября: онлайн‑буткемп (+5 баллов при посещаемости ≥70%).</li>
                <li>8.6. 31 октября 18:00 (EEST): финальный upload бренд‑пакета.</li>
                <li>8.7. 1–3 ноября: 48‑часовой хакатон и работу с менторами.</li>
                <li>8.8. 3 ноября 18:00–21:00: защита проектов (5 мин презентация + 3 мин Q&A).</li>
                <li>8.9. 5 ноября: подведение итогов, публикация результатов, feedback‑отчёты.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>9. Состав и квалификация жюри</h3>
              <ul className='brandhackathon__list'>
                <li>9.1. Коллегия — 20 независимых экспертов из 14 стран.</li>
                <li>9.2. Отраслевая коллегия — топовые специалисты мирового уровня.</li>
                <li>9.3. Профессора, CMO, креативные директора глобальных брендов.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>10. Механизм оценки</h3>
              <ul className='brandhackathon__list'>
                <li>10.1. Анонимизация: до live‑питча жюри видит только ID‑код.</li>
                <li>10.2. Круг 1 (26 сент. – 5 окт.): оценка тремя судьями, средний балл (max 100).</li>
                <li>10.3. Круг 2 (21 – 25 окт.): согласование расхождений >15 баллов.</li>
                <li>10.4. Live‑питч 30 % оценки; бонусы 10 %.</li>
                <li>10.5. Полная рубрика критериев в «Гайде участника».</li>
                <li>10.6. Arbitраж при Judge Variance Index > 2 σ.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>11. Призы и награды</h3>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr><th>Номинация</th><th>Награда</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>BrandGlobe Mastermind Grand Prix</td>
                      <td>Кубок BrandGlobe, $10 000 на медиазапуск, менторство CEO МАМИ</td>
                    </tr>
                    <tr>
                      <td>Cross‑Culture Navigator Award</td>
                      <td>Грант на локализацию, годовое членство в Guild</td>
                    </tr>
                    <tr>
                      <td>Digital Innovation Trailblazer</td>
                      <td>Грант Google Cloud, премиум‑SaaS, выступление на Summit</td>
                    </tr>
                    <tr>
                      <td>Всем финалистам</td>
                      <td>Дипломы CPD, доступ к акселератору, медиаподдержка</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="reg-section">
              <h3>12. Права интеллектуальной собственности</h3>
              <ul className='brandhackathon__list'>
                <li>12.1. Авторские права остаются за командами.</li>
                <li>12.2. МАМИ получает опцион инвестирования на 6 мес.</li>
                <li>12.3. Публикация контента только с указанием авторства и МАМИ.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>13. Этические и юридические нормы</h3>
              <ul className='brandhackathon__list'>
                <li>13.1. Запрещены hate‑speech, дискриминация, порнография, пропаганда.</li>
                <li>13.2. Все участники подписывают NDA.</li>
                <li>13.3. Нарушение норм влечёт дисквалификацию.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>14. Контакты Оргкомитета</h3>
              <p>
                E‑mail: info@mami.com.ua<br/>
                www.mami.org.ua<br/>
                вул. Воздвиженська, 41, Київ, Украина<br/>
                Тел.: +38 (067) 657‑24‑02
              </p>
            </div>

            <div className="reg-section">
              <h3>Приложение 1. Календарь‑шпаргалка</h3>
              <ul className='brandhackathon__list'>
                <li>1 июля — открытие регистрации</li>
                <li>15 сентября — крайний срок подачи заявки</li>
                <li>25 сентября — объявление short‑list</li>
                <li>1–3 ноября — основной Хакатон</li>
                <li>5 ноября — публикация результатов, награждение</li>
              </ul>
            </div>

            <div className="reg-section">
              <p>
                Настоящее Положение вступает в силу с момента публикации на официальном сайте МАМИ и действует до утверждения следующего сезона.
              </p>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RegulationModal;
